// components/MainContent.js
import React from "react";
import * as S from "./style.admin";

const Body = ({ children }: any) => {
  return <S.MainContent className="admin">{children}</S.MainContent>;
};

export default Body;
